// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZZ_4","title":"Header_title__26ZeK","left":"Header_left__Ff2Ud","clinicName":"Header_clinicName__cN_53"};